import React from 'react';

const About = () => {
    return (
        <div className='container'>
            <p>name:Habiza Noor Hussain</p>
            <p>Goal: my goal is to be a full stack developer. my plan is after completing this course i am going to learn python and also some backend stuff . my plan is to migrate to canada and actually i am preparing myself for that so that i can get myself a it related job.</p>
        </div>
    );
};

export default About;